var _circle, _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgUsdc = function SvgUsdc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.597,
    cy: 12.335,
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.642 19.465c0 .26-.178.347-.445.347-3.289-1.043-5.6-4-5.6-7.477 0-3.478 2.311-6.434 5.6-7.477.267-.087.445.087.445.347v.609a.477.477 0 0 1-.267.435c-2.578.956-4.356 3.304-4.356 6.086 0 2.782 1.867 5.217 4.356 6.086.178.087.267.261.267.435v.609Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.308 17.29c0 .175-.178.349-.355.349h-.711c-.178 0-.356-.174-.356-.348v-1.044c-1.422-.173-2.133-.956-2.4-2.086 0-.174.089-.348.267-.348h.8c.177 0 .266.087.355.26.178.61.534 1.131 1.69 1.131.888 0 1.51-.435 1.51-1.13 0-.696-.355-.957-1.6-1.13-1.866-.261-2.755-.783-2.755-2.261 0-1.13.889-2 2.133-2.174V7.466c0-.174.178-.348.356-.348h.71c.178 0 .356.174.356.348v1.043c1.067.174 1.778.783 1.956 1.74 0 .173-.09.347-.267.347h-.711c-.178 0-.267-.087-.356-.26-.177-.61-.622-.87-1.422-.87-.889 0-1.333.434-1.333 1.043s.266.957 1.6 1.13c1.867.261 2.755.783 2.755 2.261 0 1.13-.888 2.087-2.222 2.347v1.044Z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.997 19.812c-.267.087-.444-.087-.444-.347v-.61c0-.173.088-.347.266-.434 2.578-.956 4.356-3.304 4.356-6.086 0-2.782-1.867-5.217-4.356-6.086a.477.477 0 0 1-.266-.435v-.609c0-.26.177-.347.444-.347 3.2 1.043 5.6 4 5.6 7.477 0 3.478-2.311 6.434-5.6 7.477Z",
    fill: "#000"
  })));
};

export default SvgUsdc;